import { useEffect, useState, useRef } from "react";

const DEMO_HORSES = [
  { number: 3, name: "Not Over The Top", driver: "Kjell Vidar Braaten", distribution: 44.3, odds: 2.15 },
  { number: 6, name: "E.C. Dream S.C.", driver: "Jonny Kongevold", distribution: 29.8, odds: 3.64 },
  { number: 4, name: "Gaio Noark", driver: "Per Vetle Kals", distribution: 10.8, odds: 8.90 },
  { number: 2, name: "Venus de Milo", driver: "Kenneth Handeland", distribution: 8.1, odds: 12.40 },
  { number: 5, name: "Too Young", driver: "Johan Kringeland Eriksen", distribution: 4.1, odds: 24.00 },
  { number: 7, name: "Be My Love", driver: "Arne Daniel Halvorsen", distribution: 1.5, odds: 65.00 },
];

const DEMO_BONG = {
  gameType: "V65",
  trackName: "Sørlandet",
  legs: { 1: "1,2,3/4,5,6", 2: "5", 3: "1,2/3,4,5", 4: "1,2,3", 5: "5/6,7", 6: "1,2,3" },
  horseNames: { 2: "Kul Stilling", 5: "Lesja Odin" },
  cost: 54,
  costLarge: 810,
  hasSplit: true,
};

export default function OverlayDemo() {
  const [showOdds, setShowOdds] = useState(false);
  const [showBong, setShowBong] = useState(false);
  const [showLower, setShowLower] = useState(false);
  const [showBanker, setShowBanker] = useState(false);
  const [visibleRows, setVisibleRows] = useState(0);
  const [activeView, setActiveView] = useState("odds");

  // Staggered row animation
  useEffect(() => {
    if (showOdds) {
      setVisibleRows(0);
      DEMO_HORSES.forEach((_, i) => {
        setTimeout(() => setVisibleRows(v => v + 1), 150 + i * 120);
      });
    } else {
      setVisibleRows(0);
    }
  }, [showOdds]);

  // Auto-demo cycle
  useEffect(() => {
    const sequence = [
      () => { setActiveView("odds"); setShowOdds(true); setShowBong(false); setShowLower(false); setShowBanker(false); },
      () => setShowLower(true),
      () => { setShowOdds(false); setShowLower(false); },
      () => { setActiveView("bong"); setShowBong(true); },
      () => setShowBanker(true),
      () => { setTimeout(() => setShowBanker(false), 3000); },
      () => { setShowBong(false); },
    ];
    let step = 0;
    const timer = setInterval(() => {
      sequence[step % sequence.length]();
      step++;
      if (step >= sequence.length) {
        step = 0;
      }
    }, 3500);
    sequence[0]();
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{
      width: "100vw", height: "100vh", backgroundColor: "#00FF00",
      position: "relative", overflow: "hidden", fontFamily: "'Inter', sans-serif"
    }}>
      {/* Subtle grid pattern on green for depth */}
      <div style={{
        position: "absolute", inset: 0,
        backgroundImage: "radial-gradient(circle at 50% 50%, rgba(0,200,0,0.3) 0%, transparent 70%)",
      }} />

      {/* ===== ODDS OVERLAY ===== */}
      <div style={{
        position: "absolute", top: "40px", right: "40px",
        width: "520px",
        transform: showOdds ? "translateX(0)" : "translateX(600px)",
        opacity: showOdds ? 1 : 0,
        transition: "all 0.8s cubic-bezier(0.16, 1, 0.3, 1)",
      }}>
        {/* Header */}
        <div style={{
          background: "linear-gradient(135deg, #0F172A 0%, #1E3A5F 100%)",
          borderRadius: "16px 16px 0 0",
          padding: "0",
          overflow: "hidden",
          boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
        }}>
          {/* Accent bar */}
          <div style={{
            height: "4px",
            background: "linear-gradient(90deg, #F97316, #EAB308, #22C55E)",
          }} />
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "16px 24px",
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <div style={{
                width: "48px", height: "48px",
                background: "linear-gradient(135deg, #F97316, #EAB308)",
                borderRadius: "12px",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontFamily: "'Barlow Condensed', sans-serif",
                fontWeight: 800, fontSize: "1.1rem", color: "#000",
                boxShadow: "0 4px 12px rgba(249,115,22,0.4)",
              }}>
                V65
              </div>
              <div>
                <div style={{
                  fontFamily: "'Barlow Condensed', sans-serif",
                  fontSize: "1.6rem", fontWeight: 700, color: "#FFFFFF",
                  textTransform: "uppercase", letterSpacing: "0.05em",
                  lineHeight: 1.1,
                }}>
                  Avd. 1
                </div>
                <div style={{
                  fontSize: "0.8rem", color: "#94A3B8",
                  fontFamily: "'JetBrains Mono', monospace",
                }}>
                  Sørlandet • 2140m • Volte
                </div>
              </div>
            </div>
            <div style={{
              display: "flex", flexDirection: "column", alignItems: "flex-end",
            }}>
              <div style={{
                fontSize: "0.65rem", color: "#22C55E",
                fontFamily: "'JetBrains Mono', monospace",
                textTransform: "uppercase", letterSpacing: "0.15em",
                display: "flex", alignItems: "center", gap: "6px",
              }}>
                <span style={{
                  width: "6px", height: "6px", borderRadius: "50%",
                  backgroundColor: "#22C55E",
                  animation: "pulse-glow 2s ease-in-out infinite",
                }} />
                Direkteodds
              </div>
              <div style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: "0.7rem", color: "#64748B", marginTop: "2px",
              }}>
                Rikstoto.no
              </div>
            </div>
          </div>
        </div>

        {/* Horse rows */}
        <div style={{
          background: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(20px)",
          borderRadius: "0 0 16px 16px",
          overflow: "hidden",
          boxShadow: "0 16px 48px rgba(0,0,0,0.3)",
        }}>
          {DEMO_HORSES.map((horse, i) => {
            const isVisible = i < visibleRows;
            const isTop = i === 0;
            return (
              <div key={horse.number} style={{
                display: "flex", alignItems: "center",
                padding: "12px 20px",
                backgroundColor: i % 2 === 0 ? "rgba(255,255,255,1)" : "rgba(248,250,252,1)",
                borderBottom: "1px solid rgba(0,0,0,0.06)",
                transform: isVisible ? "translateX(0)" : "translateX(100%)",
                opacity: isVisible ? 1 : 0,
                transition: `all 0.5s cubic-bezier(0.16, 1, 0.3, 1) ${i * 0.06}s`,
              }}>
                {/* Number */}
                <div style={{
                  width: "40px", height: "40px",
                  background: isTop ? "linear-gradient(135deg, #F97316, #EAB308)" : "#0F172A",
                  color: isTop ? "#000" : "#FFF",
                  borderRadius: "10px",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontFamily: "'JetBrains Mono', monospace",
                  fontWeight: 800, fontSize: "1.2rem",
                  flexShrink: 0,
                  boxShadow: isTop ? "0 4px 12px rgba(249,115,22,0.3)" : "none",
                }}>
                  {horse.number}
                </div>

                {/* Name & Driver */}
                <div style={{ flex: 1, marginLeft: "14px", overflow: "hidden" }}>
                  <div style={{
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: 700, fontSize: "1rem", color: "#0F172A",
                    whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                  }}>
                    {horse.name}
                  </div>
                  <div style={{
                    fontSize: "0.75rem", color: "#64748B", marginTop: "1px",
                  }}>
                    {horse.driver}
                  </div>
                </div>

                {/* Distribution bar */}
                <div style={{ width: "90px", marginRight: "16px" }}>
                  <div style={{
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: "0.85rem", fontWeight: 600,
                    color: isTop ? "#F97316" : "#0F172A",
                    textAlign: "right", marginBottom: "4px",
                  }}>
                    {horse.distribution.toFixed(1)}%
                  </div>
                  <div style={{
                    height: "5px", borderRadius: "3px",
                    backgroundColor: "rgba(0,0,0,0.08)",
                    overflow: "hidden",
                  }}>
                    <div style={{
                      width: isVisible ? `${Math.min(horse.distribution, 100)}%` : "0%",
                      height: "100%", borderRadius: "3px",
                      background: isTop
                        ? "linear-gradient(90deg, #F97316, #EAB308)"
                        : "linear-gradient(90deg, #3B82F6, #6366F1)",
                      transition: `width 1s cubic-bezier(0.16, 1, 0.3, 1) ${0.3 + i * 0.1}s`,
                    }} />
                  </div>
                </div>

                {/* Odds */}
                <div style={{
                  fontFamily: "'JetBrains Mono', monospace",
                  fontWeight: 800,
                  fontSize: isTop ? "1.5rem" : "1.2rem",
                  color: "#0F172A",
                  minWidth: "70px", textAlign: "right",
                }}>
                  {horse.odds.toFixed(2)}
                </div>
              </div>
            );
          })}

          {/* Footer */}
          <div style={{
            padding: "10px 20px",
            background: "linear-gradient(135deg, #0F172A 0%, #1E3A5F 100%)",
            display: "flex", justifyContent: "space-between", alignItems: "center",
          }}>
            <div style={{
              display: "flex", alignItems: "center", gap: "8px",
            }}>
              <div style={{
                width: "80px", height: "32px",
                backgroundImage: "url(/sorlandet-logo.png)",
                backgroundSize: "contain", backgroundRepeat: "no-repeat",
                backgroundPosition: "center", opacity: 0.8,
              }} />
            </div>
            <div style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "0.7rem", color: "#64748B",
            }}>
              Sørlandets Travpark
            </div>
          </div>
        </div>
      </div>

      {/* ===== BONG OVERLAY ===== */}
      <div style={{
        position: "absolute", bottom: "100px", left: "60px",
        width: "380px",
        transform: showBong ? "translateY(0) scale(1)" : "translateY(40px) scale(0.95)",
        opacity: showBong ? 1 : 0,
        transition: "all 0.7s cubic-bezier(0.16, 1, 0.3, 1)",
      }}>
        <div style={{
          background: "rgba(255,255,255,0.97)",
          backdropFilter: "blur(24px)",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0,0,0,0.35), 0 0 0 1px rgba(255,255,255,0.1)",
        }}>
          {/* Bong Header */}
          <div style={{
            background: "linear-gradient(135deg, #0F172A 0%, #1E3A5F 100%)",
            padding: "0",
          }}>
            <div style={{
              height: "4px",
              background: "linear-gradient(90deg, #F97316, #EAB308, #22C55E)",
            }} />
            <div style={{
              padding: "16px 24px",
              display: "flex", alignItems: "center", justifyContent: "space-between",
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{
                  width: "42px", height: "42px",
                  background: "linear-gradient(135deg, #F97316, #EAB308)",
                  borderRadius: "10px",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontFamily: "'Barlow Condensed', sans-serif",
                  fontWeight: 800, fontSize: "1rem", color: "#000",
                }}>
                  V65
                </div>
                <div>
                  <div style={{
                    fontFamily: "'Barlow Condensed', sans-serif",
                    fontSize: "1.4rem", fontWeight: 700, color: "#FFF",
                    textTransform: "uppercase", letterSpacing: "0.05em",
                  }}>
                    Spillforslag
                  </div>
                  <div style={{
                    fontSize: "0.75rem", color: "#94A3B8",
                    fontFamily: "'JetBrains Mono', monospace",
                  }}>
                    Sørlandet
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bong Legs */}
          <div style={{ padding: "8px 0" }}>
            {Object.entries(DEMO_BONG.legs).map(([leg, horses], i) => {
              const smallPart = horses.includes("/") ? horses.split("/")[0] : horses;
              const isBanker = smallPart.split(",").filter(h => h.trim()).length === 1;
              const displayText = horses.replace("/", " / ");
              return (
                <div key={leg} style={{
                  display: "flex", alignItems: "center",
                  padding: "10px 24px",
                  backgroundColor: i % 2 === 0 ? "rgba(255,255,255,1)" : "rgba(248,250,252,1)",
                  borderBottom: "1px solid rgba(0,0,0,0.05)",
                }}>
                  <div style={{
                    fontFamily: "'Barlow Condensed', sans-serif",
                    fontWeight: 700, fontSize: "1rem", color: "#0F172A",
                    width: "70px",
                  }}>
                    V65-{leg}
                  </div>
                  <div style={{
                    flex: 1, textAlign: "right",
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: "1rem", fontWeight: 600,
                    color: "#0F172A",
                  }}>
                    {displayText}
                    {isBanker && (
                      <span style={{
                        marginLeft: "10px",
                        background: "linear-gradient(135deg, #F97316, #EAB308)",
                        color: "#000", padding: "2px 8px", borderRadius: "6px",
                        fontSize: "0.75rem", fontWeight: 800,
                      }}>B</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Cost Footer */}
          <div style={{
            padding: "14px 24px",
            background: "linear-gradient(135deg, #F8FAFC, #F1F5F9)",
            borderTop: "2px solid rgba(0,0,0,0.08)",
            display: "flex", justifyContent: "space-between", alignItems: "center",
          }}>
            <div style={{
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 700, fontSize: "0.9rem", color: "#64748B",
              textTransform: "uppercase", letterSpacing: "0.05em",
            }}>
              Kostnad
            </div>
            <div style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontWeight: 800, fontSize: "1.3rem", color: "#0F172A",
            }}>
              54 kr <span style={{ color: "#94A3B8", fontSize: "0.9rem" }}>/</span> 810 kr
            </div>
          </div>
        </div>
      </div>

      {/* ===== LOWER THIRD ===== */}
      <div style={{
        position: "absolute", bottom: "60px", left: "50%",
        transform: showLower ? "translateX(-50%) translateY(0)" : "translateX(-50%) translateY(100px)",
        opacity: showLower ? 1 : 0,
        transition: "all 0.6s cubic-bezier(0.16, 1, 0.3, 1)",
        zIndex: 10,
      }}>
        <div style={{
          background: "linear-gradient(135deg, #0F172A 0%, #1E3A5F 100%)",
          borderRadius: "14px",
          overflow: "hidden",
          boxShadow: "0 12px 40px rgba(0,0,0,0.4)",
          minWidth: "500px",
        }}>
          <div style={{
            height: "3px",
            background: "linear-gradient(90deg, #F97316, #EAB308, #22C55E)",
          }} />
          <div style={{
            display: "flex", alignItems: "center", gap: "20px",
            padding: "14px 28px",
          }}>
            <div style={{
              width: "100px", height: "50px",
              backgroundImage: "url(/sorlandet-logo.png)",
              backgroundSize: "contain", backgroundRepeat: "no-repeat",
              backgroundPosition: "center", flexShrink: 0,
            }} />
            <div style={{ borderLeft: "2px solid rgba(255,255,255,0.1)", height: "40px" }} />
            <div>
              <div style={{
                fontFamily: "'Barlow Condensed', sans-serif",
                fontSize: "1.8rem", fontWeight: 700, color: "#FFF",
                textTransform: "uppercase", letterSpacing: "0.03em",
                lineHeight: 1.1,
              }}>
                Kjell Vidar Braaten
              </div>
              <div style={{
                fontSize: "0.85rem", color: "#94A3B8",
                fontFamily: "'Inter', sans-serif",
                marginTop: "2px",
              }}>
                Kusk • Not Over The Top
              </div>
            </div>
            <div style={{
              marginLeft: "auto",
              background: "linear-gradient(135deg, #F97316, #EAB308)",
              borderRadius: "10px", padding: "8px 16px",
              fontFamily: "'JetBrains Mono', monospace",
              fontWeight: 800, fontSize: "1.1rem", color: "#000",
            }}>
              #3
            </div>
          </div>
        </div>
      </div>

      {/* ===== BANKER ALERT ===== */}
      {showBanker && (
        <div style={{
          position: "absolute", inset: 0,
          display: "flex", alignItems: "center", justifyContent: "center",
          zIndex: 20,
          animation: "banker-flash 0.3s ease-out",
        }}>
          <div style={{
            background: "linear-gradient(135deg, rgba(15,23,42,0.97), rgba(30,58,95,0.97))",
            backdropFilter: "blur(30px)",
            borderRadius: "24px",
            padding: "48px 64px",
            textAlign: "center",
            boxShadow: "0 0 80px rgba(249,115,22,0.3), 0 0 160px rgba(234,179,8,0.15)",
            border: "2px solid rgba(249,115,22,0.3)",
            animation: "banker-scale 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
          }}>
            <div style={{
              fontFamily: "'Barlow Condensed', sans-serif",
              fontSize: "1.2rem", fontWeight: 600,
              color: "#F97316", textTransform: "uppercase",
              letterSpacing: "0.3em", marginBottom: "8px",
            }}>
              Banker
            </div>
            <div style={{
              fontFamily: "'Barlow Condensed', sans-serif",
              fontSize: "4rem", fontWeight: 800,
              background: "linear-gradient(135deg, #F97316, #EAB308)",
              WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
              lineHeight: 1.1,
            }}>
              Kul Stilling
            </div>
            <div style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "1.2rem", color: "#94A3B8",
              marginTop: "12px",
            }}>
              #5 • V65-3 • 57.4%
            </div>
          </div>
        </div>
      )}

      {/* ===== CRAWL BAR ===== */}
      <div style={{
        position: "absolute", bottom: 0, left: 0, right: 0,
        height: "36px",
        background: "linear-gradient(135deg, #0F172A 0%, #1E3A5F 100%)",
        display: "flex", alignItems: "center",
        overflow: "hidden",
        boxShadow: "0 -4px 20px rgba(0,0,0,0.3)",
      }}>
        <div style={{
          background: "linear-gradient(135deg, #F97316, #EAB308)",
          padding: "0 16px", height: "100%",
          display: "flex", alignItems: "center",
          fontFamily: "'Barlow Condensed', sans-serif",
          fontWeight: 700, fontSize: "0.85rem", color: "#000",
          textTransform: "uppercase", letterSpacing: "0.05em",
          flexShrink: 0, zIndex: 1,
        }}>
          V65-1
        </div>
        <div style={{
          flex: 1, overflow: "hidden", whiteSpace: "nowrap",
        }}>
          <div style={{
            display: "inline-block",
            fontFamily: "'Inter', sans-serif",
            fontSize: "0.85rem", color: "#E2E8F0",
            paddingLeft: "100%",
            animation: "crawl-scroll 25s linear infinite",
          }}>
            3. Not Over The Top (44.3%) • 6. E.C. Dream S.C. (29.8%) • 4. Gaio Noark (10.8%) • 2. Venus de Milo (8.1%) • 5. Too Young (4.1%) • 7. Be My Love (1.5%)
          </div>
        </div>
      </div>

      {/* Control buttons (demo only) */}
      <div style={{
        position: "absolute", top: "16px", left: "16px",
        display: "flex", gap: "8px", zIndex: 30,
      }}>
        {[
          { label: "Odds", fn: () => setShowOdds(v => !v), active: showOdds },
          { label: "Bong", fn: () => setShowBong(v => !v), active: showBong },
          { label: "Super", fn: () => setShowLower(v => !v), active: showLower },
          { label: "Banker", fn: () => setShowBanker(v => !v), active: showBanker },
        ].map(b => (
          <button key={b.label} onClick={b.fn} style={{
            padding: "8px 16px", borderRadius: "8px",
            background: b.active ? "rgba(249,115,22,0.9)" : "rgba(15,23,42,0.8)",
            color: "#FFF", border: "none", cursor: "pointer",
            fontFamily: "'Inter', sans-serif", fontSize: "0.8rem", fontWeight: 600,
            backdropFilter: "blur(10px)",
          }}>
            {b.label}
          </button>
        ))}
      </div>

      <style>{`
        @keyframes crawl-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
        @keyframes pulse-glow {
          0%, 100% { opacity: 1; box-shadow: 0 0 4px rgba(34,197,94,0.6); }
          50% { opacity: 0.5; box-shadow: 0 0 8px rgba(34,197,94,0.3); }
        }
        @keyframes banker-scale {
          0% { transform: scale(0.8); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
        @keyframes banker-flash {
          0% { background-color: rgba(249,115,22,0.15); }
          100% { background-color: transparent; }
        }
      `}</style>
    </div>
  );
}
